import { UserRole } from 'shared/types/userRole';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { PermissionConfig } from '../types';

export const CREATE_SITE_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: true,
  [UserRole.manager]: false,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

const EDIT_SITE_PERMISSIONS: PermissionConfig = CREATE_SITE_PERMISSIONS;

export const SitePermissionManager =
  PermissionManagerFactory.create({
    permissionConfigForCreate: CREATE_SITE_PERMISSIONS,
    permissionConfigForEdit: EDIT_SITE_PERMISSIONS,
    permissionConfigForDelete: null,
  });
